import ListIcon from 'components/record/ListIcon';
import Tooltips from 'components/tooltips/Tooltips';

/**
 * A link inside a row, as on the prototype: plain text until hovered, then
 * framed in white. It opens what it names (a company's panel) without opening
 * the row. `icon` sits in a small white square before the label.
 */
const CellButton = ({ icon: Icon, tooltip, onClick, children }) => (
  <Tooltips text={tooltip} placement="top">
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onClick(event);
      }}
      className="-ml-1.5 flex min-w-0 max-w-full items-center gap-3 rounded-lg border border-transparent px-1.5 py-1 text-left text-gray-700 transition-colors hover:border-gray-200 hover:bg-white"
    >
      {Icon && (
        <ListIcon icon={Icon} size="xs" />
      )}
      <span className="truncate">{children}</span>
    </button>
  </Tooltips>
);

export default CellButton;
